export default __webpack_public_path__ + "static/media/certified-by-NEN7510.687287ec.svg";